<template>
    <div class="bh-upload-wrap">
        <mt-cell v-if="readOnly && fileData.length===0" :title="label" :readonly="readOnly" :titlewidth="titlewidth" :value-align="textalign">
        </mt-cell>
        <mt-cell class="is-vertical mint-uploadimgs" v-if="(!readOnly) || (readOnly && fileData.length>0)" :readonly="readOnly" :title="label"  :disabledcolor="disabled" :required="required" :titlewidth="titlewidth" :value-align="textalign" ></mt-cell>
        <div>
            <template v-for="(item,index) in fileData">
                <template v-if="isImage(item) === true">
                    <div class="upload_item">
                        <i v-if='!readOnly' class="iconfont icon-weiwancheng cancel_upload_img" @click="deleteImg(item.id)"></i>
                        <img class="upload_img" @click="previewImg(index)" :src="getFileByUrl(item.fileUrl)" alt="">
                    </div>
                </template>
                <template v-if="isImage(item) === false">
                    <div class="upload_item">
                        <i v-if='!readOnly' class="iconfont icon-weiwancheng cancel_upload_img" @click="deleteImg(item.id)"></i>
                        <a :href="item.fileUrl"><i @click="previewFile(item)" class="iconfont" :class="getFileType(item)" style="font-size:75px;"></i></a>     
                    </div>
                </template>
            </template>
            <template v-if="fileData.length < maxNumber && !readOnly">
                <div class="upload_item">
                    <img class="upload_img" src="../../static/img/upload.png" alt="无" @click="handleClick">
                </div>
            </template>
        </div>
        <mt-actionsheet :actions="materialActions" v-model="materialSheetVisible"></mt-actionsheet>
    </div>
</template>
<script>
    import Vue from 'vue';
    import utils from '../utils'

    export default {
        name : "emapm-upload-imgs", 
        props: {
            label:'',
            disabled:'',
            hostPathname: { //带二级域名：用于图片上传需要整个域名前缀
                default: location.origin + location.pathname.substring(0, location.pathname.indexOf("/", 1)),
                type: String
            },
            token: { //附件的token
                default: '',
                type: String
            },
            index: {//如果此组件是循环渲染出来的，此属性代表当前索引值
                default: 0,
                type: Number
            },
            maxNumber: { //允许上传的最大图片数
                default: 9,
                type: Number
            },
            size: { //要限制的图片的大小（单位：KB）
                default: 5000,
                type: Number
            },
            readOnly: {
                default: false,
                type: Boolean
            },
            required: {
                default: false,
                type: Boolean
            },
            titlewidth:{
                type: String,
                default: function() {
                    return '';
                }
            },
            textalign: {
                type: String,
                default: function() {
                    return '';//flex-start
                }
            },
            fileName: {
                default:''
            }
        },
        watch: {
            token(val) {
                this.myToken = val;
                this.getImgsToDom();
            },
            myToken(val) {
                this.$emit('on-token-change', val,this.index);
            }
        },
        data() {
            var _this = this;
            return {
                host: "",
                myToken: this.token,
                fileData: [],
                previewUrl: [],
                materialSheetVisible: false,
                materialActions: [{
                    name: "拍照",
                    method: _this.handleShootClick
                }, {
                    name: "从相册中选择",
                    method: _this.handleSelectClick
                }],
            }
        },
         mounted() {
            var path = this.hostPathname;
            var pArr = [];
            for(var i=0;i<path.length;i++){
                if(path[i] == "/"){
                    pArr.push(i)
                }
            }
            this.host = path.substring(0,pArr[pArr.length-1]);
            this.getImgsToDom();
        },
        methods: {
            getImgsToDom() {
                console.log('getImgsToDom----'+this.myToken)
                if (this.myToken) {
                    let url = this.hostPathname + '/sys/emapcomponent/file/getUploadedAttachment/' + this.myToken + '.do';                    
                    //debugger
                    window.MINT.Indicator.open();
                    // 根据token获取 图片链接数组
                    utils.Get(url).then(({ data: resp }) => {
                        window.MINT.Indicator.close();
                        this.fileData = resp.items || []
                        this.previewUrl = [];
                        this.fileData.map(item => {
                            this.previewUrl.push({
                                isImage:item.isImage,
                                fileUrl:item.fileUrl
                            });
                        });
                        // 2018-08-16 人事 王长春 已有token但无图片，保持token不变 by xujiabin
                        // if(this.previewUrl.length === 0){
                        //     this.myToken = '';
                        // }
                    },() => {
                        window.MINT.Indicator.close();
                    })
                } else {
                    this.fileData = [];
                }
            },
            previewImg(index){
                let imgs = [];
                this.previewUrl.map(item => {
                    if (item.isImage) {
                        let opt = {};
                        opt.url = this.host + item.fileUrl;
                        imgs.push(opt);
                    }
                })
                //某些第三方的app环境下utils.getJsSDK().preViewImages()和 BH_MIXIN_SDK 都不能用。
                //只能用SDK，所以应用在初始化SDK的时候将SDK挂载在window下是必须的
                if(utils.getJsSDK().preViewImages){
                    utils.getJsSDK().preViewImages(imgs,index);
                } else if(SDK){
                    SDK.preViewImages(imgs,index);
                }
            },
            getFileByUrl(url) {
                return this.host + url;
            },
            handleClick() {
                this.materialSheetVisible = true
            },
            handleSelectClick() {
                this.materialSheetVisible = false;
                let num = this.maxNumber - this.fileData.length;
                //某些第三方的app环境下utils.getJsSDK().takePhoto()和 BH_MIXIN_SDK 都不能用。
                //只能用SDK，所以应用在初始化SDK的时候将SDK挂载在window下是必须的
                if(utils.getJsSDK() && utils.getJsSDK().takePhoto){
                    utils.getJsSDK().takePhoto((ret) => {
                        //console.log('start-------actionUpload');
                        //alert(JSON.stringify(ret));
                        this.actionUpload(ret);
                    }, num)
                } else if(SDK){
                    SDK.takePhoto((ret) => {
                        //console.log('start-------actionUpload');
                        //alert(JSON.stringify(ret));
                        this.actionUpload(ret);
                    }, num)
                } else {
                    alert("emap-mobile内的SDK加载出现问题，请联系管理员")                    
                }
                
            },
            handleShootClick() {
                this.materialSheetVisible = false;
                let num = this.maxNumber - this.fileData.length;
                //某些第三方的app环境下utils.getJsSDK().takeCamera()和 BH_MIXIN_SDK 都不能用。
                //只能用SDK，所以应用在初始化SDK的时候将SDK挂载在window下是必须的
                if(utils.getJsSDK() && utils.getJsSDK().takeCamera){
                    utils.getJsSDK().takeCamera((ret) => {
                        //console.log('start-------actionUpload');
                        //console.log(ret);
                        this.actionUpload(ret)
                    }, num)
                } else if(SDK){
                    SDK.takeCamera((ret) => {
                        //console.log('start-------actionUpload');
                        //alert(JSON.stringify(ret));
                        this.actionUpload(ret);
                    }, num)
                } else {
                    alert("emap-mobile内的SDK加载出现")                    
                }
                
            },
            deleteImg(wid) {
                console.log('--1--2--------')
                console.log(window.MINT.MessageBox)
                window.MINT.MessageBox({
                    message: "确定删除该照片",
                    title: "提示",
                    showCancelButton: true,
                    confirmButtonClass: "confirm_btn_class",
                    cancelButtonClass: "cancel_btn_class"
                }).then(action => {
                    if (action == "confirm") {
                        let url1 = this.hostPathname + '/sys/emapcomponent/file/deleteFileByWid/' + wid + '.do';
                        let url2 = this.hostPathname + '/sys/emapcomponent/file/deleteFileByWid/' + wid + "_1" + '.do';
                        let url3 = this.hostPathname + '/sys/emapcomponent/file/deleteFileByWid/' + wid + "_2" + '.do';
                        window.MINT.Indicator.open();
                        //测试发现现在emap底座的删除接口，在删除图片时，必须保证 _1 和 _2 都已经删除成功了才能删除原图
                        utils.Get(url2).then(data => {
                            utils.Get(url3).then(data => {
                                utils.Get(url1).then(data => {
                                    window.MINT.Indicator.close();
                                    this.getImgsToDom();
                                })
                            })
                        })
                    }
                })
            },
            actionUpload(retData) {
                var that = this;
                if (retData.length == 0) {
                    return
                }
                let url = [];
                //alert(JSON.stringify(url))
                let sizeFlag = 0;
                // alert('retData.length:'+retData.length)
                // alert('isArray:'+(retData instanceof Array))
                // alert('isString:'+(retData instanceof String))
                if (Array.isArray(retData)) {
                    retData.map(item => {
                        url.push(item.url);
                        //alert(JSON.stringify(url))
                        if(item.size >= this.size  * 1024){
                            sizeFlag ++;
                        }
                    })
                    if(sizeFlag > 0){
                        window.MINT.Toast('图片大小限制在'+ this.size + 'KB以内');
                        return
                    }
                } else {
                    if (retData.url) {
                        url[0] = retData.url;
                    } 
                    // else {
                    //     retData.map(item => {
                    //         url.push(item.url);
                    //     }) 
                    // }
                    //alert(JSON.stringify(url))
                    if(retData.size >= this.size  * 1024){
                        window.MINT.Toast('图片大小限制在'+ this.size + 'KB以内');
                        return
                    }
                }
                
                window.MINT.Indicator.open();
                let config = {
                    token: this.myToken || ''
                };
                if (this.fileName && this.maxNumber === 1) {
                    config.fileName = this.fileName;
                }
                console.log('uploadImgsToEmap~~~~~~~~')
                //alert(JSON.stringify(url))
                //某些第三方的app环境下utils.getJsSDK().uploadImgsToEmap()和 BH_MIXIN_SDK 都不能用。
                //只能用SDK，所以应用在初始化SDK的时候将SDK挂载在window下是必须的
                if(utils.getJsSDK() && utils.getJsSDK().uploadImgsToEmap){
                    utils.getJsSDK().uploadImgsToEmap({
                        host: that.hostPathname,
                        urls: url,
                        config: config
                    }).then(resp => {
                        window.MINT.Indicator.close();
                        console.log('uploadImgsToEmap---------'+JSON.stringify(resp))
                        //resp.data.token 兼容学工线的微信上传图片
                        //resp.datas 兼容人事 教务微信上传图片的接口 add by jbx 20181015 from 孟斌，陈杨
                        if(resp.datas){
                            this.myToken = resp.datas;
                            this.getImgsToDom();
                            window.MINT.Toast('图片上传成功')
                        }else if (resp.token || resp.data.token) {
                            this.myToken = resp.token || resp.data.token;
                            this.getImgsToDom();
                            window.MINT.Toast('图片上传成功')
                        } else {
                            window.MINT.Toast(resp.msg || '图片上传失败')
                        }
                    }, error => {
                        console.log('error-----------1')
                        console.log(JSON.stringify(error))
                        window.MINT.Indicator.close();
                        window.MINT.Toast('图片上传失败~')
                    })
                } else if(SDK){
                    SDK.uploadImgsToEmap({
                        host: that.hostPathname,
                        urls: url,
                        config: config
                    }).then(resp => {
                        window.MINT.Indicator.close();
                        console.log('uploadImgsToEmap---------'+JSON.stringify(resp))
                        //resp.data.token 兼容学工线的微信上传图片
                        //resp.datas 兼容人事 教务微信上传图片的接口 add by jbx 20181015 from 孟斌，陈杨
                        if(resp.datas){
                            this.myToken = resp.datas;
                            this.getImgsToDom();
                            window.MINT.Toast('图片上传成功')
                        }else if (resp.token || resp.data.token) {
                            this.myToken = resp.token || resp.data.token;
                            this.getImgsToDom();
                            window.MINT.Toast('图片上传成功')
                        } else {
                            window.MINT.Toast(resp.msg || '图片上传失败')
                        }
                    }, error => {
                        console.log('error-----------1')
                        console.log(JSON.stringify(error))
                        window.MINT.Indicator.close();
                        window.MINT.Toast('图片上传失败~')
                    })
                } else {
                    alert("emap-mobile内的SDK加载出现")                    
                }

            },
            isImage(fileItemData) {
                if (fileItemData.name === undefined) return
                if (/.(jpg|jpeg|png|gif|bmp)$/.test(fileItemData.name.toLowerCase())) return true
                return false
            },
            getFileType(fileItemData){
                if (/.(xls|xlsx)$/.test(fileItemData.name.toLowerCase())) return 'icon-xlsx color-xlsx';
                if (/.(pdf)$/.test(fileItemData.name.toLowerCase())) return 'icon-pdf color-pdf';
                if (/.(zip)$/.test(fileItemData.name.toLowerCase())) return 'icon-zip';
                if (/.(doc|docx)$/.test(fileItemData.name.toLowerCase())) return 'icon-doc color-doc';
                if (/.(ppt|pptx)$/.test(fileItemData.name.toLowerCase())) return 'icon-ppt color-ppt';
                return 'icon-others color-others';
            },
            previewFile(item){
                if (utils.getJsSDK().bh && utils.getJsSDK().bh.file.filePreview) {
                    var lastIndex = item.name.lastIndexOf('.');
                    var type = item.name.slice(lastIndex + 1,item.name.length);
                    console.log('filesType:'+type)
                    utils.getJsSDK().bh.file.filePreview(item.fileUrl,type,''); 
                } else if(SDK) {
                    var lastIndex = item.name.lastIndexOf('.');
                    var type = item.name.slice(lastIndex + 1,item.name.length);
                    console.log('filesType:'+type)
                    SDK.filePreview(item.fileUrl,type,''); 
                }
            }
        }
    }
</script>
<style>
    .confirm_btn_class {
        font-size: 14px;
    }
    .cancel_btn_class {
        font-size: 14px;
    }
</style>
<style scoped>
    .bh-upload-wrap {
        position: relative;
        /* overflow: hidden; */
        width: 100%;
        /* display: flex!important; */
    }
    .bh-upload_required{
        color: red;
    }
    .upload_item {
        display: inline-block;
        width: 75px;
        height: 75px;
        margin: 0px 8px 12px 0;
        position: relative;
        vertical-align: top;
    }
    .upload_item_none{
        line-height: 75px;
        margin: 0;
    }
    .cancel_upload_img {
        position: absolute;
        top: -13px;
        right: -7px;
        font-size: 18px;
    }
    .upload_img {
        width: 75px;
        height: 75px;
    }
    .upload_img_wrong{
        width: 100px;
        margin: 0;
        line-height: 75px;        
    }
    .bh-upload-wrap .color-pdf {
        color: #F26666;
    }

    .bh-upload-wrap .color-doc {
        color: #4A90E2;
    }

    .bh-upload-wrap .color-xlsx {
        color: #A2D06B;
    }

    .bh-upload-wrap .color-ppt {
        color: #F26666;
    }

    .bh-upload-wrap .color-zip {
        color: #92969C;
    }

    .bh-upload-wrap .color-others {
        color: #FFB950;
    }

</style>


// WEBPACK FOOTER //
// emapm-upload-imgs.vue?408db5b6